<template>
    <div class="mainPage">
      <!-- <img src="../img/pakistan/敬请期待.jpg" alt="" class="coming"> -->
        <div class="header_banner">
            <div slot="logincon" class="loginWrapper">
                <div v-if="!isLogin">
                    <span @click="toLogin()">{{ $t('message.login') }}</span> | 
                    <span @click="toLogin()">{{ $t('message.register') }}</span>
                </div>
                <div v-if="isLogin">
                    <span><span>{{user.username}}</span><span @click="toLogOut()">{{ $t('message.logout') }}</span> </span>
                </div>
            </div>
          <div class="infoCon">
            <img src="../img/pakistan/banner.png" alt="" class="banner">
          </div>
        </div>
        <div class="contentCon">
          <div class="courseListCon">
            <div class="classTypeList">
              <h2 class="">
                初级班  Beginner Class
              </h2>
              <h3 @click="changeTab(1)" :class="{'active': activeTab == 1}">
                HSK1
              </h3>
              <h3 @click="changeTab(2)" :class="{'active': activeTab == 2}">
                HSK2
              </h3>
              <h2 class="">
                初级班（儿童） 
                <div>
                  Beginner Class (For Children)
                </div>
              </h2>
              <h3 @click="changeTab(3)" :class="{'active': activeTab == 3}">
                YCT1
              </h3>
              <h3 @click="changeTab(4)" :class="{'active': activeTab == 4}">
                YCT2
              </h3>
              <h2 class="">
                中级班  Intermediate Class      
              </h2>
              <h3 @click="changeTab(5)" :class="{'active': activeTab == 5}">
                HSK3
              </h3>
              <h3 @click="changeTab(6)" :class="{'active': activeTab == 6}">
                HSK4（A+B）
              </h3>
              <h2 class="">
                高级班  Advanced Class    
              </h2>
              <h3 @click="changeTab(7)" :class="{'active': activeTab == 7}">
                HSK5（A）
              </h3>
              <h3 @click="changeTab(8)" :class="{'active': activeTab == 8}">
                HSK5（B）
              </h3>
              <h3 @click="changeTab(9)" :class="{'active': activeTab == 9}">
                HSK6（A）
              </h3>
              <h3 @click="changeTab(10)" :class="{'active': activeTab == 10}">
                HSK6（B）
              </h3>
            </div>
            <div class="list">
                <div class="currentInfo">
                  <div>
                    <div v-if="currentCourseList.length>0 && (currentCourseList[0].category == 1|| currentCourseList[0].category == 2)" class="title">
                      <div >
                        初级班: <span>{{currentCourseList[0].name}}</span>
                      </div>
                      <div >
                        Beginner Class: <span>{{currentCourseList[0].name_en}}</span>
                      </div>
                    </div>
                    <div v-if="currentCourseList.length>0 && (currentCourseList[0].category == 3|| currentCourseList[0].category == 4)" class="title">
                      <div>
                        初级班（儿童）: <span>{{currentCourseList[0].name}}</span>
                      </div>
                      <div>
                        Beginner Class (For Children): <span>{{currentCourseList[0].name_en}}</span>
                      </div>
                    </div>
                    <div v-if="currentCourseList.length>0 && (currentCourseList[0].category == 5|| currentCourseList[0].category == 6)" class="title">
                      <div>
                        中级班  : <span>{{currentCourseList[0].name}}</span>
                      </div>
                      <div>
                        Intermediate Class: <span>{{currentCourseList[0].name_en}}</span>
                      </div>
                    </div>
                    <div v-if="currentCourseList.length>0 && (currentCourseList[0].category >6)" class="title">
                      <div>
                        高级班: <span>{{currentCourseList[0].name}}</span>
                      </div>
                      <div>
                        Advanced Class: <span>{{currentCourseList[0].name_en}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="teacherInfo" v-if="currentCourseList.length>0">
                    <div >
                      授课教师：<span>{{currentCourseList[0].teacher_name}}</span> <span class="teacherTitle">({{currentCourseList[0].teacher_title}})</span>
                    </div>
                    <div>
                      课程学习时间：<span v-if="currentCourseList[0].category<5">2022年5月28日至8月20日</span><span v-if="currentCourseList[0].category>=5">2022年5月25日至8月20日
                      </span>
                    </div>
                    <div>
                      <span v-if="currentCourseList[0].category<5">
                      北京时间每周六18:00 - 20:15（巴基斯坦时间15:00 - 17:15）
                      </span>
                      <span v-if="currentCourseList[0].category>=5">
                      北京时间每周三、周六18:00 - 20:15（巴基斯坦时间15:00 - 17:15）
                      </span>
                    </div>
                  </div>
                  <div class="teacherInfo-en" v-if="currentCourseList.length>0">
                    <div v-if="currentCourseList[0].teacher_name_en">
                      Instructor: <span>{{currentCourseList[0].teacher_name_en}}</span> <span class="teacherTitle">({{currentCourseList[0].teacher_title_en}})</span>
                    </div>
                    <div>
                      Class Time: 
                      <span v-if="currentCourseList[0].category<5">
                      From May 28 to August 20, 2022
                      </span>
                      <span v-if="currentCourseList[0].category>=5">
                      From May 25 to August 20, 2022
                      </span>
                    </div>
                    <div>
                    <span v-if="currentCourseList[0].category<5">
                      Every Saturday 18:00 - 20:15 Beijing time (15:00 - 17:15 Pakistan time)
                    </span>
                    <span v-if="currentCourseList[0].category>=5">
                      Every Wednesday and Saturday 18:00 - 20:15 Beijing time (15:00 - 17:15 Pakistan time)
                    </span>
                      
                    </div>
                  </div>
                </div>
                <div class="line"></div>
                
                <div class="following-dates">
                  具体日期 <span>Schedule</span>
                </div>
                <div class="eg">
                  <div class="soon">
                    <span></span>
                    <span>
                      即将直播  Live Soon
                    </span>
                  </div>
                  <div class="current">
                    <span></span>
                    <span>
                      当前直播  Live
                    </span>
                  </div>
                  <div class="completed">
                    <span></span>
                    <span>
                      课程回放  Playback
                    </span>
                  </div>
                </div>
                <ul>
                  <li v-for="(item, index) in currentCourseList" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}">
                    <div class="coming" v-if="item.customStatus == 0">
                      <div class="num">
                        {{index+1}}
                      </div>
                      <span class="date">
                        {{item.customDate}}
                      </span>
                      <!-- <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1"> -->
                    </div>
                    <div class="live" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                      <div class="num">
                        {{index+1}}
                      </div>
                      <span class="date">
                        {{item.customDate}}
                      </span>
                      <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1">
                    </div>
                    <!-- <div class="live" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                      <div class="num">
                        {{index+1}}
                      </div>
                      <span class="date">
                        {{item.customDate}}
                      </span>
                      <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1">
                    </div> -->
                    <div class="finished" v-if="item.customStatus == 2" @click="replay(item.video_url, item.status, item.id)">
                      <div class="num">
                        {{index+1}}
                      </div>
                      <span class="date">
                        {{item.customDate}}
                        <div class="viewCount">
                          <div>
                            <img src="../img/pakistan/live.svg" alt="" class="icon live">
                            {{item.room_count}}
                          </div>
                          <div>
                            <img src="../img/pakistan/eye.svg" alt="" class="icon eye">
                            {{item.lesson_count}}
                          </div>
                        </div>
                      </span>
                      <!-- <img src="../img/pakistan/play_icon.png" alt="" class="playIcon" v-if="item.customStatus == 1"> -->
                    </div>


                    <!-- <div class="titleCon">
                        <div class="liveBtn">
                            <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                <span class="En">
                                    Join
                                </span>
                                <span class="Cn">
                                    加入
                                </span>
                            </span>
                            <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url)">
                                <span class="En">
                                    Replay
                                </span>
                                <span class="Cn">
                                    课程回放
                                </span>
                            </span>
                            <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                直播未开始 Coming Soon
                            </span>
                            <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                <span class="En">
                                    Enter
                                </span>
                                <span class="Cn">
                                    进入
                                </span>
                            </span>
                        </div>
                    </div> -->
                </li>
                </ul>
                
            </div>
        </div>
        <div>
          <img src="../img/pakistan/tower.png" alt="" class="tower">
          <img src="../img/pakistan/footer.png" alt="" class="footer">
        </div>
        <!-- <pcfooter></pcfooter> -->
        </div>
        
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
// import ztHeader from './ztHeader'
// import pcfooter from './footer'
export default {
    name: 'chinesebridge',
    components: {
      // ztHeader,
      // pcfooter
    },
    data: function () {
        return {
            isChrome: true,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            isShowGuide: true,
            subject_info: {},
            courseList: [],
            currentCourseList: [],
            activeTab: 1,
            subject_id: null,
            beforeTime: 60, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    methods: {
        changePage(page, url) {
            // this.currentMenu = page
            if(url) {
                window.open(url); 
            }
        },
        changeTab(tab) {
            this.activeTab = tab
            this.currentCourseList = []
            this.courseList.forEach(e => {
              if(tab == e.category) {
                this.currentCourseList.push(e)
              }
            })
        },
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                // this.getCourseInfo(this.subject_id)
            }).catch((r) => {
                console.log(r)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlistpk', {
                subject_id: id,
                limit: 400
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        e.customDate = this.getCurrentTime(e.start_time)
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }
                    })
                    // res.data.data.list.push(...res.data.data.list)
                    // res.data.data.list.push(...res.data.data.list)
                    // res.data.data.list.push(...res.data.data.list)
                    // res.data.data.list.push(...res.data.data.list)
                    this.courseList = res.data.data.list
                    this.categoryName()
                    this.changeTab(this.activeTab)
                    this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 记录学习记录
        setRecord(id) {
          this.$utils.get('/subject/lesson/setPkCount', {
              lesson_id: id
          })
        },
        getCurrentTime(time) {
          var date = new Date(time);
          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
          var D = date.getDate() + ' '
          if(D < 10) {
            D = '0'+D
          }
          return M +'-'+ D
        },
        categoryName() {
            this.courseList.forEach(e => {
                if(e.name.indexOf('HSK1') > -1) {
                    e.category = 1
                }else if(e.name.indexOf('HSK2') > -1) {
                    e.category = 2
                }else if(e.name.indexOf('YCT1') > -1) {
                    e.category = 3
                }else if(e.name.indexOf('YCT2') > -1) {
                    e.category = 4
                }else if(e.name.indexOf('HSK3') > -1) {
                    e.category = 5
                }else if(e.name.indexOf('HSK4') > -1) {
                    e.category = 6
                }else if(e.name.indexOf('HSK5（A）') > -1) {
                    e.category = 7
                }else if(e.name.indexOf('HSK5（B）') > -1) {
                    e.category = 8
                }else if(e.name.indexOf('HSK6（A）') > -1) {
                    e.category = 9
                }else if(e.name.indexOf('HSK6（B）') > -1) {
                    e.category = 10
                }
            })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        join(item, index, islive) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "03198325b8b61ccc3413cf7e754febea",
                key: "zyz",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set (this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                    }
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        joinToLive(item, index) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            if(!item.isOrder) {
                this.join(item, index, true)
            }else {
              window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
        },
        replay(url, status, id) {
          if(status == 3) {
            this.isPlay = true
            this.currentVideoUrl = url
            setTimeout(function() {
                $('#liveVideo').bind('contextmenu',function() { return false; })
            }, 50)
            this.setRecord(id)
          } else {
            this.$message({
              message: "课程回放上传中，请稍后查看",
              type: "warning",
            });
          }
            
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        checkChrome() {
            var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
            if (!isChrome) {
                this.isChrome = false
            }
        }
    },
    mounted() {
        this.getSubjectInfo('pakistan_class_live')
        this.customCheckLogin()
        let activeTab = this.$route.query.tab
        if(activeTab) {
            this.activeTab = activeTab
        }
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    .coming {
      width: 100%;
      // height: 100%;
    }
    .agentTip {
        width: 100%;
        height: 70px;
        line-height: 70px;
        background-color: #ffe6a1;
        text-align: center;
        position: absolute;
        z-index: 5;
        color: #c40000;
    }
    .agentTip .closeTip {
        position: absolute;
        right: 24px;
        top: 0px;
        font-size: 30px;
        color: #282828;
        cursor: pointer;
    }
    .loginWrapper {
      position: absolute;
      right: 60px;
      top: 36px;
      z-index: 1;
        font-size: 16px;
        color: #282828;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }.loginWrapper {
        font-size: 16px;
        color: #282828;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }
    .infoCon {
        position: relative;
        .banner {
        width: 100%;
        //   height: 250px;
        }
        .info {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 1200px;
            left: 0;
            right: 0;
            margin: auto;
            text-align: left;
            .infoName {
            width: 75%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            .name {
                font-size:38px;
                color: #fff;
                font-weight: bold;
                line-height:1.2;
            }
            .name_en {
                font-size: 30px;
                color: #fff;
                font-family: Georgia;
                margin-top: 20px;
            }
            }
        }
    }
    .contentCon {
      position: absolute;
      top: 53%;
      left: 0;
      right: 0;
      padding-bottom: 200px;
      .tower {
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .footer {

        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .courseListCon {
        width: 1420px;
        height: 1200px;
        position: relative;
        z-index: 1;
        // background-color: #457856;
        box-shadow: 0px 2px 5px 0px 
          rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        border: solid 5px #457856;
        margin: auto;
        
        .classTypeList {
          width: 370px;
          height: 100%;
          display: inline-block;
          vertical-align: top;
          background-color: rgba(#457856, 0.8);
          text-align: left;
          padding-left: 42px;
          box-sizing: border-box;
          h2 {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: 0px;
            color: #f1c72f;
            margin: 20px 0 10px;
          }
          h3 {
            width: 308px;
	          height: 60px;
            line-height: 60px;
            
            color: #fff;
            cursor: pointer;
            &.active {
              width: 328px;
              margin-left: -20px;
              padding-left: 20px;
              // box-sizing: border-box;
              background-color: #355e41;
	            border-radius: 10px 0px 0px 10px;
              position: relative;
              &:after {
                position: absolute;
                right: 13px;
                top: 0;
                bottom: 0;
                margin: auto;
                content: '';
                display: inline-block;
                width: 9px;
                height: 17px;
                background-image: url(../img/pakistan/arrow.png);
              }
            }
          }
        }
        .liveClass {
            padding-top: 60px;
            margin-bottom: 58px;
        }
        .list {
            width: 1050px;
            height: 100%;
            position: relative;
            text-align: left;
            display: inline-block;
            vertical-align: top;
            overflow-y: auto;
            text-align: center;
            background-color: rgba(#fff, 0.8);
            .currentInfo {
              margin: 43px 0 0 57px;
              text-align: left;
              .title {
                div:first-child {
                  font-family: SourceHanSansCN-Regular;
                  font-size: 40px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 1.1;
                  letter-spacing: 0px;
                  color: #457856;
                  // margin-bottom: 10px;
                }
                div:last-child {
                  font-size: 36px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 1.1;
                  letter-spacing: 0px;
                  color: #457856;
                }
              }
              .teacherInfo {
                margin-top: 35px;
                div:first-child {
                  font-size: 18px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 24px;
                  letter-spacing: 0px;
                  color: #282828;
                  .teacherTitle {
                    font-size: 14px;
                    color: #78847c;
                    margin-left: 10px;
                  }
                }
                div:nth-child(2) {
                  font-size: 18px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 24px;
                  letter-spacing: 0px;
                  color: #282828;
                }
                div:last-child {
                  font-size: 18px;
                  line-height: 24px;
                  font-weight: normal;
                  letter-spacing: 0px;
                  color: #457856;
                }
              }
              .teacherInfo-en {
                margin-top: 35px;
                div:first-child {
                  font-size: 18px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 24px;
                  letter-spacing: 0px;
                  color: #282828;
                  .teacherTitle {
                    font-size: 14px;
                    color: #78847c;
                    margin-left: 10px;
                  }
                }
                div:nth-child(2) {
                  font-size: 18px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 24px;
                  letter-spacing: 0px;
                  color: #282828;
                }
                div:last-child {
                  font-size: 18px;
                  line-height: 24px;
                  font-weight: normal;
                  letter-spacing: 0px;
                  color: #457856;
                }
              }
            }
            .line {
              margin-top: 30px;
              width: 920px;
              height: 1px;
              margin: 30px auto;
              background-color: #457856;
            }
            .following-dates {
              font-family: SourceHanSansCN-Regular;
              font-size: 24px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 30px;
              letter-spacing: 0px;
              color: #457856;
              span {
                font-family: DIN-Medium;
                font-size: 24px;
                font-weight: normal;
                letter-spacing: 0px;
                color: #457856;
              }
            }
            .eg {
              text-align: center;
              margin-top: 31px;
              div {
                display: inline-block;
                margin-right: 45px;
                span:first-child {
                  display: inline-block;
                  width: 20px;
                  height: 20px;
                  vertical-align: text-top;
                }
              }
              .soon {
                span:first-child {
                  background-color: #457856;
                }
              }
              .current {
                span:first-child {
                  background-color: #f1c72f;
                }
              }
              .completed {
                span:first-child {
                  background-color: #93a4aa;
                }
              }
            }
            ul {
              padding: 0 93px 0 140px;
              margin-top: 52px;
              text-align: left;
            }
            li {
                width: 176px;
                display: inline-block;
                margin-right: 35px;
                margin-bottom: 32px;
                text-align: left;
                cursor: pointer;
                .num {
                  display: inline-block;
                  text-align: center;
                  width: 50px;
                  height: 50px;
                  line-height: 50px;
                  background-color: #457856;
                  border-radius: 5px;
                  font-family: DIN-Medium;
                  font-size: 30px;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0px;
                  color: #ffffff;
                  margin-right: 5px;
                }
                .date {
                  font-family: DIN-Medium;
                  font-size: 30px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 30px;
                  letter-spacing: 0px;
                  color: #282828;
                  display: inline-block;
                  vertical-align: top;
                }
                .playIcon {
                  float: right;
                  margin-top: 18px;
                }
                & .live {
                  .num {
                    background-color: #f1c72f;
                    color: #457856;
                  }
                }
                .finished .num{
                  background-color: #93a4aa;
                }
                .viewCount {
                  vertical-align: top;
                  font-size: 12px;
                  line-height: 20px;
                  color:#8da6ac;
                  height: 20px;
                  div {
                    display: inline-block;
                    vertical-align: middle;
                    font-family: DIN-Light;
                    height: 18px;
                    line-height: 18px;
                    .icon {
                      // width: 14px;
                      vertical-align: text-bottom;
                    }
                    .live {
                      height: 18px;
                      vertical-align: sub;
                    }
                    .eye {
                      height: 12px;
                      margin-left: 5px;
                      vertical-align: middle;
                    }
                  }
                }
                .titleCon {
                    .title {
                        color: #fd9c29;
                        display: inline-block;
                        .en {
                            font-size: 24px;
                            font-family: 'Georgia';
                            margin-bottom: 2px;
                            width: 800px;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 18px;
                            width: 800px;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        .join {
                            display: inline-block;
                            height: 50px;
                            line-height: 1.2;
                            border-radius: 25px;
                            background-color: #fd9c29;
                            color: #fff;
                            padding: 15px 31px;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 22px;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 20px;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #4a88da;
                            color: #fff;
                        }
                        .isOrder {
                            color: #999;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
        }
    }
    .guideModel {
        position: fixed;
        right: 0;bottom: 40px;
        z-index: 5;
        cursor: pointer;
        .close {
            font-size: 28px;
            position: absolute;
            top: 15px;right: 15px;
            color: #fff;
            cursor: pointer;
        }
    }
    #videoPlayWrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999;
    }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 62%;
    }
    video::-internal-media-controls-download-button {
        display:none;
    }
    video::-webkit-media-controls-enclosure {
        overflow:hidden;
    }
    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }
}

</style>
